import React from 'react'
import Appraisalreportfile from '../../components/conditionreportcomponents/Appraisalreportfile'

function  Appraisalreport({renderPageContent}) {
    return (
        <>
                        <Appraisalreportfile renderPageContent={renderPageContent}/>
        </>
    )
}

export default  Appraisalreport
